module.exports = __webpack_public_path__ + "img/80.d6905eee.jpg";